import { datadogRum } from '@datadog/browser-rum';

import type { Environment } from '../config';

export const loadDatadogRUM = (environment: Environment) => {
  if (environment === 'production') {
    datadogRum.init({
      applicationId: 'b4f2ceb4-3893-4363-bf50-88cdf4f4f989',
      clientToken: 'pub16fb51fe922b0dbd3aa3e8903df192d8',
      site: 'datadoghq.com',
      service: 'sbiz-ui',
      env: environment,
      trackUserInteractions: true,
      defaultPrivacyLevel: 'mask-user-input',
      silentMultipleInit: true, // Enable initialization fails silently if the RUM Browser SDK is already initialized on the page.
    });
    datadogRum.startSessionReplayRecording();
  }
};
